module.exports = __webpack_public_path__ + "static/gear-ca64541a9a2f986fe545389f5a5ec606.gif";